import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import ModalPortal from '@App/kit/components/Popups/ModalPortal'
import { StoresContext } from '@App/contexts'
import RoyaltiesSidebar from '@Components/Sidebars/RoyaltiesSidebar'
import RightsholderRoyaltiesHead from '@Scenes/RightsholderScene/RightsholderRoyalties/RightsholderRoyaltiesHead'
import RoyaltiesUsagePeriod from '@Scenes/RightsholderScene/RightsholderRoyalties/RoyaltiesUsagePeriod'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PayeeRoyalties } from '@Entities/statements/payee-royalties'
import { useOutletContext } from 'react-router'
import { RoyaltiesStatementsContext } from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/hooks/useRoyaltiesStatements'
import PointPreloader from '@Components/Preloaders/PointPreloader'

const RightsholderRoyalties = () => {
    const { statementsStore } = useContext(StoresContext)
    const { loading, useRoyaltiesForPeriod } = useOutletContext<RoyaltiesStatementsContext>()
    const [sidebarIsOpen, setSidebarIsOpen] = useState(false)
    const [selectedData, setSelectedData] = useState<PayeeRoyalties>()

    useEffect(() => {
        analyticsSendPage('rightsholder_royalties')
    }, [])

    return (
        <>
            <title>Royalties Summary</title>
            <div className="royalties-summary-wrapper">
                <RightsholderRoyaltiesHead
                    setUsagePeriod={useRoyaltiesForPeriod}
                    usagePeriod={statementsStore.selectedUsagePeriod}
                />
                <div className="preloader-container">{loading && <PointPreloader />}</div>
                {!loading && (
                    <RoyaltiesUsagePeriod setSelectedData={setSelectedData} setSidebarIsOpen={setSidebarIsOpen} />
                )}
            </div>
            <ModalPortal isOpen={sidebarIsOpen} onClose={() => setSidebarIsOpen(false)}>
                <RoyaltiesSidebar closeSidebar={() => setSidebarIsOpen(false)} data={selectedData} />
            </ModalPortal>
        </>
    )
}

export default observer(RightsholderRoyalties)
